import { createContext, useContext, type ComponentPropsWithRef, type MouseEvent, type ReactNode } from "react";

type Navigate = (href: string) => void;

const NavigateContext = createContext<Navigate>((href) => {
  window.location.assign(href);
});

export function NavigateProvider({ navigate, children }: { navigate: Navigate; children: ReactNode }) {
  return <NavigateContext.Provider value={navigate}>{children}</NavigateContext.Provider>;
}

export function useAppNavigate(): Navigate {
  return useContext(NavigateContext);
}

export interface AppLinkProps extends Omit<ComponentPropsWithRef<"a">, "href"> {
  href: string;
}

export function AppLink({ href, onClick, className, ...props }: AppLinkProps) {
  const navigate = useAppNavigate();
  const handle = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    )
      return;
    event.preventDefault();
    navigate(href);
  };
  return <a href={href} onClick={handle} className={className ?? "text-link"} {...props} />;
}
